"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _storePoint = require("@/api/storePoint");

var logistics = _interopRequireWildcard(require("@/api/logistics"));

var _systemConfig = require("@/api/systemConfig");

var _index2 = _interopRequireDefault(require("../../../../appSetting/wxAccount/wxTemplate/index"));

var _validate = require("@/utils/validate");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var _default = {
  name: "index",
  components: {
    Templates: _index2.default
  },
  // props: {
  //   children: 'child',
  //   label: 'name',
  //   value: 'name'
  // },
  data: function data() {
    var _this2 = this;

    var validatePhone = function validatePhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('请填写手机号'));
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确!'));
      } else {
        callback();
      }
    };

    var validateUpload = function validateUpload(rule, value, callback) {
      if (!_this2.ruleForm.image) {
        callback(new Error('请上传提货点logo'));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      dialogFormVisible: false,
      modalMap: false,
      keyUrl: '',
      addresData: [],
      ruleForm: {
        name: '',
        introduction: '',
        phone: '',
        address: '',
        detailedAddress: '',
        dayTime: '',
        image: '',
        latitude: ''
      },
      id: 0,
      dayTime: ['', ''],
      rules: {
        name: [{
          required: true,
          message: '请输入提货点名称',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          message: '请选择提货点地址',
          trigger: 'change'
        }],
        dayTime: [{
          required: true,
          type: 'array',
          message: '请选择提货点营业时间',
          trigger: 'change'
        }],
        phone: [{
          required: true,
          validator: validatePhone,
          trigger: 'blur'
        }],
        detailedAddress: [{
          required: true,
          message: '请输入详细地址',
          trigger: 'blur'
        }],
        image: [{
          required: true,
          validator: validateUpload,
          trigger: 'change'
        }],
        latitude: [{
          required: true,
          message: '请选择经纬度',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.ruleForm.image = '';
    var cityList = JSON.parse(sessionStorage.getItem('cityList'));
    this.addresData = cityList;
    this.getCityList();
    this.getKey();
  },
  mounted: function mounted() {
    window.addEventListener('message', function (event) {
      // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
      var loc = event.data;

      if (loc && loc.module === 'locationPicker') {
        // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
        window.parent.selectAdderss(loc);
      }
    }, false);
    window.selectAdderss = this.selectAdderss;
  },
  methods: {
    //详情
    getInfo: function getInfo(id) {
      var _this3 = this;

      var that = this;
      that.id = id;
      this.loading = true;
      (0, _storePoint.storeInfoApi)({
        id: id
      }).then(function (res) {
        that.ruleForm = res;
        that.ruleForm.address = res.address.split(",");
        that.dayTime = res.dayTime.split(",");
        _this3.loading = false;
      });
    },
    //取消
    cancel: function cancel() {
      this.dialogFormVisible = false;
      this.clearFrom();
      this.ruleForm.image = '';
      this.resetForm('ruleForm');
      this.id = 0;
    },
    //重置
    resetForm: function resetForm(name) {
      this.$refs[name].resetFields();
    },
    // 提交
    submitForm: (0, _validate.Debounce)(function (name) {
      var _this4 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          (0, _storePoint.storeSaveApi)(_this4.ruleForm).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee() {
            return _index.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this4.$message.success('提交成功');

                    _this4.dialogFormVisible = false;

                    _this4.$parent.tableList();

                    _this4.$parent.storeGetCount();

                    _this4.clearFrom();

                    _this4.resetForm(name);

                    _this4.id = 0;

                  case 7:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          })));
        } else {
          return false;
        }
      });
    }),
    //编辑
    editForm: (0, _validate.Debounce)(function (name) {
      var _this5 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this5.handleChange(_this5.ruleForm.address);

          (0, _storePoint.storeUpdateApi)(_this5.ruleForm, _this5.id).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee2() {
            return _index.default.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this5.$message.success('编辑成功');

                    _this5.dialogFormVisible = false;

                    _this5.$parent.tableList();

                    _this5.clearFrom();

                    _this5.resetForm(name);

                    _this5.id = 0;

                  case 6:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          })));
        } else {
          return false;
        }
      });
    }),
    //数据归为初始状态
    clearFrom: function clearFrom() {
      this.ruleForm.introduction = '';
      this.dayTime = ['', ''];
    },
    //确认省市区
    handleChange: function handleChange(e) {
      var province = e[0];
      var city = e[1];
      var area = e[2];

      if (e.length === 2) {
        this.ruleForm.address = province + ',' + city;
      } else if (e.length === 3) {
        this.ruleForm.address = province + ',' + city + ',' + area;
      }
    },
    //营业时间
    onchangeTime: function onchangeTime(e) {
      this.ruleForm.dayTime = e ? e.join(',') : '';
    },
    //上传图片
    modalPicTap: function modalPicTap(tit) {
      var _this = this;

      this.$modalUpload(function (img) {
        _this.ruleForm.image = img[0].sattDir;
      }, tit, 'system');
    },
    //查找位置
    onSearch: function onSearch() {
      this.modalMap = true;
    },
    // 选择经纬度
    selectAdderss: function selectAdderss(data) {
      this.ruleForm.latitude = data.latlng.lat + ',' + data.latlng.lng;
      this.modalMap = false;
    },
    // key值
    getKey: function getKey() {
      var _this6 = this;

      var _pram = {
        id: 74
      };
      (0, _systemConfig.configInfo)(_pram).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee3(res) {
          var keys;
          return _index.default.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  keys = res.tengxun_map_key;
                  _this6.keyUrl = "https://apis.map.qq.com/tools/locpicker?type=1&key=".concat(keys, "&referer=myapp");

                case 2:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    getCityList: function getCityList() {
      var _this7 = this;

      logistics.cityListTree().then(function (res) {
        sessionStorage.setItem('cityList', JSON.stringify(res));
        var cityList = JSON.parse(sessionStorage.getItem('cityList'));
        _this7.addresData = cityList;
      }).catch(function (res) {
        _this7.$message.error(res.message);
      });
    }
  }
};
exports.default = _default;